import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as PointSettingAPI from "@/api/point-setting";
import { isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/point-setting/request";
import { RegisterResponse } from "@/api/point-setting/response";

const MODULE_NAME = "point-setting/regist";

/**
 * ポイントカード設定登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  registerResponse: RegisterResponse = {} as RegisterResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.registerResponse);
  }

  get getMessage() {
    return this.registerResponse.message;
  }

  get getPreviewUrl() {
    if (this.registerResponse.results) {
      return this.registerResponse.results.previewUrl;
    } else {
      return "";
    }
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const registerResponse = await PointSettingAPI.register(registerRequest);
    return {
      registerResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      registerResponse: {} as RegisterResponse
    };
  }
}

export default getModule(Modify);
